export default "__VITE_ASSET__2ecf1040__"